import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";

// Accueil : rappel tant que l'annulation d'abonnement par le client reste ACTIVÉE dans le Customer Portal Stripe (vérifié en direct via Santé Stripe).
export function PortalCancelAlert() {
  const [c, setC] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { api.get("/billing/stripe-health").then((r) => setC((r.data.checks || []).find((x) => x.key === "portal_cancel") || null)).catch(() => setC(null)); }, []);
  if (!c || c.ok || c.level !== "critical") return null;
  return (
    <div className="mx-6 md:mx-8 lg:mx-10 mt-4 rounded-xl border border-amber-500/60 bg-amber-500/[0.08] p-4 flex flex-wrap items-center justify-between gap-3" data-testid="portal-cancel-alert">
      <div>
        <p className="text-[10px] uppercase tracking-[0.2em] text-amber-300 font-semibold">Stripe · à faire par toi</p>
        <h3 className="text-zinc-100 font-bold mt-0.5">Les membres peuvent encore annuler leur abonnement seuls depuis le portail Stripe</h3>
        <p className="text-xs text-zinc-400 mt-0.5">Paramètres → Facturation → Portail client → « Annulations » → désactiver « Permettre aux clients d'annuler leur abonnement » → Enregistrer. Cette alerte disparaît automatiquement dès que c'est fait.</p>
      </div>
      <div className="flex gap-2">
        <a href={c.url} target="_blank" rel="noreferrer" className="px-3 py-1.5 rounded-lg bg-amber-400 hover:bg-amber-300 text-black text-xs font-bold" data-testid="portal-cancel-open-stripe">Ouvrir le Dashboard Stripe →</a>
        <button onClick={() => navigate("/app/membres-paiements?tab=sante")} className="px-3 py-1.5 rounded-lg bg-zinc-800 hover:bg-zinc-700 text-xs text-zinc-200" data-testid="portal-cancel-health">Santé Stripe</button>
      </div>
    </div>
  );
}
